export enum UploadType {
    TABLE = 'TABLE',
    TABLE_AND_GEOMETRY = 'TABLE_AND_GEOMETRY',
    UNKNOWN = 'UNKNOWN' // when the upload was just created, we don't know its type
}
